/* eslint-disable @typescript-eslint/no-unused-expressions */
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { UserService } from 'app/pages/com.usblick.common/auth/user.service';
import { ItineraryService } from 'app/shared/itinerary.service';
import { Observable } from 'rxjs';
import { setting } from '../../../../../setting';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NotificationService } from '../../../shared/notifications/notification.service';

/** Fee bancario registrado, agrupado por moneda de pago. */
export interface BankFeeSummary {
  currency: string;
  net: number;
  fee: number;
  total: number;
  percentage: number | null;
}

@Component({
  selector: 'usb-documentation',
  templateUrl: './documentation.component.html',
  styleUrls: ['./documentation.component.scss']
})
export class DocumentationComponent implements OnInit, OnChanges {
  @Input() items: any;
  @Input() totalPrice: any;
  @Input() paymentMethods;
  @Input() itinerary;
  @Input() amountBLickoinsItineraryPay = 0;
  @Input() amountBLickoinsItineraryPayUSD = 0;
  @Input() amountBLickoinsItineraryPayAgency = 0;
  @Input() amountCardItineraryPay = 0;
  @Input() amountDepositItineraryPay = 0;
  @Input() amountDepositItineraryPayUSD = 0;
  @Input() amountDepositItineraryPayAgency = 0;
  @Input() amountTransferItineraryPay = 0;
  @Input() paymentMastersRaw: any[] = [];
  // Pagos registrados en esta transacción (subconjunto de paymentMastersRaw)
  @Input() currentPaymentMasters: any[] = [];
  @Input()
  currencyItinerary!: string;
  @Input()
  type!: string;
  @Input() currencyPayment: any;
  @Input() currencyAgency: any;
  @Input() currencies: any;

  @Input() amountTransferItineraryPayUSD: any;
  @Input() amountTransferItineraryPayAgency: any;

  @Input() totalPaymentPrice!: any;
  @Input() amountFilterNull!: any;
  @Input() partialLeftCreditCard!: any;
  @Input() creditCardPayPartial: any;
  @Input() creditCardDataPending!: any;

  itinerary$!: Observable<any[]>;


  activeVoucher = false;
  selectedItems: any = [];
  itineraryItems: any = [];
  voucherInfo: any;
  public bookingURL: string;

  element_!: HTMLElement;

  getClientsSettingAppBooking: any;
  downloadAllVoucher = false;
  private downloadAllVoucherInit = false;

  constructor(private itineraryService: ItineraryService,
              private userService: UserService,
              private notificationService: NotificationService,
              private http: HttpClient
             ) {
              this.getClientsSettingAppBooking = JSON.parse(localStorage.getItem(setting.name));
              this.bookingURL = setting.apiBookingUrl;
             }
  ngOnChanges(changes: SimpleChanges): void {
  }

  ngOnInit() {
    this.items.forEach(element => {
      if(element.id == 3){
        this.activeVoucher=true;
      }
      this.selectedItems.push(element);
    });

    if(this.items.length > 1) {
      this.downloadAllVoucher = true;
    }
          // Verificar si todos los objetos tienen id igual a 2
    const allIdsAreTwo = this.paymentMethods.every((payment: any) => payment.id === 2);

    // Si todos los ids son 2, sumar los montos de los objetos
    if (allIdsAreTwo) {
        this.totalPrice = this.paymentMethods.reduce((total: number, payment: any) => total + payment.amount, 0);
    }

  }

  vouchersReservationPdf(id: number) {

    this.itineraryService.voucherDownload(id, this.getClientsSettingAppBooking.id, 'only', 1, this.currencyAgency);
  }


  // Descarga en lote

async allVouchersReservationPdf(): Promise<void> {
  // ✅ Verificar si ya hay una descarga en proceso
  if (this.downloadAllVoucher) {
    console.warn('Descarga en proceso');
    return;
  }

  // ✅ Activar flag de descarga
  this.downloadAllVoucher = true;

  // ✅ Mostrar toast de inicio
  this.notificationService.loading(`Descargando ${this.items.length} vouchers...`);

  const successCount = 0;
  const errorCount = 0;

  try {
    for (let i = 0; i < this.items.length; i++) {
      const item = this.items[i];

      const headers = new HttpHeaders()
          .set('x-api-user', setting.booking_api_user)
          .set('x-api-key', setting.booking_api_key);

      const url = `${this.bookingURL}downloadVouchers/${item.id}/${this.getClientsSettingAppBooking.id}`;

        // ✅ Usar HttpClient con responseType: 'blob'
  this.http.get(url, {
    headers,
    responseType: 'blob'
  }).subscribe({
    next: (blob) => {

        this.notificationService.closeLast(); // Limpiar toast de carga
        this.notificationService.success('Voucher descargado correctamente');

      const link = document.createElement('a');
      const blobUrl = window.URL.createObjectURL(blob);
      link.href = blobUrl;
      link.download = `Voucher_${item?.id}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    },
    error: (error) => {
      this.notificationService.closeLast;
      console.error('Error al descargar:', error);
      this.notificationService?.error('Error al descargar el itinerario');
    }
  });

    }

  } catch (error) {
    console.error('Error en el proceso de descarga:', error);
    this.notificationService.error('Error en el proceso de descarga');
  } finally {
    // ✅ Finalizar descarga
    this.downloadAllVoucher = false;
    this.notificationService.clear();

    // ✅ Mostrar resumen
    if (errorCount === 0 && successCount > 0) {
      this.notificationService.success(
        `✅ ${successCount} vouchers descargados correctamente`);
    } else if (errorCount > 0 && successCount > 0) {
      this.notificationService.warning(
        `⚠️ ${successCount} descargados, ${errorCount} con errores`);
    } else if (errorCount > 0 && successCount === 0) {
      this.notificationService.error(
        `❌ Error al descargar todos los vouchers`);
    }
  }
}


  handleItem(item){
    //this.step = step;
    const itemFound = this.selectedItems.find(element => element.id == item.id);
    if(itemFound){
      const index = this.selectedItems.indexOf(itemFound);
      if (index > -1) {
        this.selectedItems.splice(index, 1);
      }
    }else{
      this.selectedItems.push(item);
    }
  }

  loadImage(url) {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.src = url;
    });
  }

  // Suma lo pagado por un producto individual (details[].uid) a partir de la
  // respuesta cruda de paymentMasters/listByItinerary, separando USD de moneda
  // de agencia, ya que un mismo producto puede figurar en más de un payment master.
  getItemPaidAmount(itemId: number): { usd: number; agency: number } {
    const result = { usd: 0, agency: 0 };

    if (!this.paymentMastersRaw || this.paymentMastersRaw.length === 0) {
      return result;
    }

    this.paymentMastersRaw.forEach((master: any) => {
      (master.details || []).forEach((detail: any) => {
        if (Number(detail.uid) === Number(itemId)) {
          const amount = parseFloat(detail.amount_payment) || 0;
          if (detail.currency_payment === 'USD') {
            result.usd += amount;
          } else {
            result.agency += amount;
          }
        }
      });
    });

    return result;
  }

  /**
   * Fee bancario registrado por el backend en un conjunto de pagos (paymentMasters), agrupado por
   * moneda de pago. Se toma details[0] de cada pago: savePayments repite el monto completo del
   * pago en cada detalle, así que sumar todos los detalles lo multiplicaría.
   */
  summarizeBankFees(masters: any[]): BankFeeSummary[] {
    const byCurrency = new Map<string, { net: number; fee: number; total: number; percentages: Set<number> }>();

    (masters || []).forEach((master: any) => {
      const detail = master?.details?.[0];
      if (!detail) {
        return;
      }
      const currency = detail.currency_payment || master.currency;
      const total = Number(detail.amount_payment) || 0;
      const fee = Number(detail.fee_amount_payment) || 0;
      const net = detail.amount_payment_without_fee !== null && detail.amount_payment_without_fee !== undefined
        ? Number(detail.amount_payment_without_fee)
        : total - fee;

      const entry = byCurrency.get(currency) || { net: 0, fee: 0, total: 0, percentages: new Set<number>() };
      entry.net += net;
      entry.fee += fee;
      entry.total += total;
      if (fee > 0) {
        entry.percentages.add(Number(detail.fee_percentage ?? master.fee_percentage) || 0);
      }
      byCurrency.set(currency, entry);
    });

    return Array.from(byCurrency.entries()).map(([currency, entry]) => ({
      currency,
      net: entry.net,
      fee: entry.fee,
      total: entry.total,
      // Si en la misma moneda hay pagos con distinto %, no se muestra un % único
      percentage: entry.percentages.size === 1 ? Array.from(entry.percentages)[0] : null,
    }));
  }

  /** Fee bancario de la transacción actual (lo registrado en este pago). */
  getCurrentTransactionBankFees(): BankFeeSummary[] {
    return this.summarizeBankFees(this.currentPaymentMasters).filter(summary => summary.fee > 0);
  }

  /** Fee bancario de todos los pagos del file con un método (1 Blickoins, 2 Tarjeta, 3 Depósito, 4 Transferencia). */
  getMethodBankFees(methodId: number): BankFeeSummary[] {
    const masters = (this.paymentMastersRaw || [])
      .filter((master: any) => Number(master.payment_methods_id) === methodId);
    return this.summarizeBankFees(masters).filter(summary => summary.fee > 0);
  }

  verifyAmount(id){
    const aux: any = this.paymentMethods.find(element=> element.id == id);
    if(aux){
      return aux.amount;
    }else{
      return null;
    }
  }

  stingUpperCase(str){
    const e = str.toLowerCase();
    return e.replace(/\b\w/g, l => l.toUpperCase());
  }

  verifyQuantityCategory(category): number{
    let aux = 0;
    switch (category) {
      case 'HOTELS':
        this.items.forEach(element => {
          if(element.categoryName=='HOTELS'){
            aux++;
          };
        });
        break;

        case 'TOURS':
        this.selectedItems.forEach(element => {
          if (element.categoryName == 'TOURS' && element.subCategoryId === 6) {
            aux++;
          };
        });
        break;

        case 'TICKETS':
         this.selectedItems.forEach(element => {
          if (element.categoryName == 'TOURS' && element.subCategoryId === 9) {
            aux++;
          };
        });
        break;

      case 'TRANSPORTS':
        this.items.forEach(element => {
          if(element.categoryName=='TRANSPORTS'){
            aux++;
          };
        });
        break;
      case 'INSURANCE':
        this.items.forEach(element => {
          if(element.categoryName=='INSURANCE'){
            aux++;
          };
        });
        break;

      case 'PTHEMES':
        this.items.forEach(element => {
          if(element.categoryName=='PTHEMES'){
            aux++;
          };
        });
        break;

      case 'RENT-A-CAR':
        this.items.forEach(element => {
          if(element.categoryName=='RENT-A-CAR'){
            aux++;
          };
        });
        break;
      case 'CRUISES':
        this.items.forEach(element => {
          if(element.categoryName=='CRUISES'){
            aux++;
          };
        });
        break;

      case 'DISNEY':
        this.items.forEach(element => {
          if(element.categoryName=='DISNEY'){
            aux++;
          };
        });
        break;

      default:
        break;
    }

    return aux;
  }

  verifyCategory(category): boolean{
    let aux;
    switch (category) {
      case 'HOTELS':
        aux = this.items.find(element => element.categoryName=='HOTELS');
        if(aux){
          return true;
        }else{
          return false;
        }

      case 'TOURS':
        aux = this.items.find(element => element.categoryName=='TOURS' && element.subCategoryId === 6);
        if(aux){
          return true;
        }else{
          return false;
        }

      case 'TICKETS':
        aux = this.items.find(element => element.categoryName=='TOURS' && element.subCategoryId === 9);
        if(aux){
          return true;
        }else{
          return false;
        }

      case 'RENT-A-CAR':
        aux = this.items.find(element => element.categoryName=='RENT-A-CAR');
        if(aux){
          return true;
        }else{
          return false;
        }

      case 'TRANSPORTS':
        aux = this.items.find(element => element.categoryName=='TRANSPORTS');
        if(aux){
          return true;
        }else{
          return false;
        }

      case 'PTHEMES':
        aux = this.items.find(element => element.categoryName=='PTHEMES');
        if(aux){
          return true;
        }else{
          return false;
        }

      case 'RENT-A-CAR':
        aux = this.items.find(element => element.categoryName=='RENT-A-CAR');
        if(aux){
          return true;
        }else{
          return false;
        }

      case 'CRUISES':
        aux = this.items.find(element => element.categoryName=='CRUISES');
        if(aux){
          return true;
        }else{
          return false;
        }

      case 'DISNEY':
        aux = this.items.find(element => element.categoryName=='DISNEY');
        if(aux){
          return true;
        }else{
          return false;
        }

      default:
        break;
    }
  }

  bedImage = 'data:image/png;base64,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';
tourImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDAyIDc5LjE2NDM2MCwgMjAyMC8wMi8xMy0wMTowNzoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIxLjEgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjBDMzlFMDYyMkEzRDExRUVCRUUwQkIwMTE4NzQ4MzQwIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjBDMzlFMDYzMkEzRDExRUVCRUUwQkIwMTE4NzQ4MzQwIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MEMzOUUwNjAyQTNEMTFFRUJFRTBCQjAxMTg3NDgzNDAiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MEMzOUUwNjEyQTNEMTFFRUJFRTBCQjAxMTg3NDgzNDAiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5kJJE5AAAEHUlEQVR42uxaS0tbQRQ+qRHfRBQUDUVU+tDQIBaLLbhqwU2pdVOUmoWuBJFYuxCX0ojL/gMXigoudSFi3SYq8UFqfCNoLQrWoFFUTHR6ZphIDDW5M7k3WsmBj3tzw50z38ycOY+5OkIIPAR5BA9E4kTiRDQSfegDnU53rzt82+akV1HHC8RbxBvEU8RjRDr/7wTxC7GGsCMmET9VZxgMQaEdbUe4aVOCcPN306Pp73W/JYnQmbQi/kgQCMUf3pY+1kSeIJwqEAiFk7cdEyLvEUcakAjAy3VoSuQzwqchiQCojgatiHxA+GNAIgA/16kqkWd8ykmM4eW6VSGilzXs2tpacnh4SFwuF+no6CDl5eWyG4BeDSJW2RFtbW0lwbK9vU0GBwdJXV0dycrKEmmrLVoi6aJ+IiUlhSQnJ5OkpCRitVrJv+T8/JwsLi6S7u5uYjablfqZ9GiItIuQ6OnpIU6nkzgcDmK328nW1ha5uroi4WRnZ0dp++2RiOhCl1NQ0EhDiFKlrv7s7AxwNti9z+eD9fV12NzchIODAzg5OQEkxf5LTU1l14qKCjCZTKDXK3LoSwiTTNBoFiFB5fLy8sZ9ZmYmGI1GSEhIgIuLC8DRh+XlZRgdHQVcXlBfXw/9/f1Kmy/lfXKJBo1tosbt9XpJJMGZIU1NTde7GhIU0fEl3NK6LbGq1CKXSEtLg9zcXHafmJgo+nqlTIZYolVi5Pf7ZV99LkPEeA+TQ6MMkYxoNFLjHhgYALfbDaenp7CwsAAq1M8yYl58QA8OFosF+vr6YHp6GmpqahiZu6iiHMsWBWZmZqCzs5P9Hh8fh/z8fHY/NjYWbV+PZYj8FtWCYQnzFc3NzbC3t8eeYSgCu7u7UF1dfe0/JHYrRX26jciKjKauri6Yn5+/4RgpgcbGRuYcPR4Pc5CSsiJU1+IyhfgkooWGJS0tLVBVVQWrq6uwtrYGGxsbjJjNZoOhoSFGgs6KpEzJEJmUsZGysjKGgBwdHcH+/j6Lp0KXlEQhcFKGiIsHaqXRWKfBYGAI3ZoDQaaALIWNsyJsv70impSOcEFBAZSUlADmIiKG36toSaiRWCkVtCUWPNIrzRoVtH2gJLEKlwzQeq0N8V3JkA0PD7ORxjQWsrOzr3OTUJmYmGA+hc7G3Nyckqa/8b6EXxFhEquADdHd4mXEGioaNHV+OTk5LMLNy8uDoqIiKCwshOLiYnalSRXNQ0ZGRpQuKbqXv+LlobDV+PtcDjpWsxz0oAp0AWmIERmqw6J1Efsjn3Itl1NtrI4V6GnUrAYkZnnbd3LQ41GBgOeuDnpuRCGIrzyEECWwxN81qHH0FsmPiB6GvkO8DjoMzQhKigKHoQ7ED9nD0NsGW00iMRHFlcb/9SOb+CcccSJxIuHlrwADAFIyAvDwTbhaAAAAAElFTkSuQmCC';
rentCarImage = ' data:image/png;base64,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';
locationImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAARCAYAAADpPU2iAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGwSURBVDhPfVK7SgNBFF0/QVvzBUIys5sgCNGd2U0ifoRiJZYKImJjI5jdvCNqY62VVlpo5Rf4KgXJBygWRiw0u+M9s2M0Kh4Y7t57zn3M3bF+wq7LWafhX9tN/xWW1/w5Qw2CbXqjTt0/suveC6/IiId0yMK36/5xesNNGallpctuyq55ndzetCKR4oGMKSGx5CMOHjqdQOQJgqwsYiJUdruonGZBW/iIaz4UpxYL3XkeiF7S3ld21XtigVxmgSdZ6C3BRxw8C+U7JYg73R4JDf8NQt3WgFVcgTh46CyG6jSr0ypE9H1rdAOgkW7AQ0cd5AUyqQoqdIxmADwU94ZXlh1OTVBml2aNs62C4lWxbnQavCrXqDruhs096yB1aeV2S4oCMbZDo51TkRot4ww+4poPRFsnpLfyw7ziPdA29P6z7aLK7ZS0ha/jFfk4ViuN6ASAVrkAEc2b/OX+ERGqZwJ30Ui/QC0vk6qfSSLSfiCviB5KVN+QKbt5XNDsXL8l+E7gTRrJb9DODzAaXTwy9tBQfwOvllbYpcp4V93+g/sPvOyujO/P9KjbqgkZWNYH9sr6Grx5vEsAAAAASUVORK5CYII=';
}
